import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;
`;

export const TeamWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Team = styled.div`
  width: 200px;
  height: 117px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  & > h3 {
    font-weight: bold;
    margin-top: 15px;
  }
  & > p {
    margin-top: 10px;
  }
`;

export const Versus = styled.div`
  margin: 0 35px;
  width: 100px;
  height: 100px;

  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    width: 67px;
    height: 67px;
    background-color: #f1f2f4;
    transform-origin: center;
  }

  & > span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #bbb;
    font-size: 20px;
    font-family: verdana, sans-serif;
  }
`;

export const ChartContainer = styled.ul`
  width: 100%;

  margin-top: 30px;
  & > li:not(:last-child) {
    margin-bottom: 18px;
  }
`;

export const ChartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  max-width: 100px;

  span {
    font-size: 12px;
    font-weight: 300;
    color: #222222;
  }
`;

export const ChartArea = styled.div`
  display: flex;
  height: 15px;
  width: 100%;

  div {
    flex: 1;
  }
`;

export const ChartDivider = styled.div`
  height: 100%;
  width: 1px;
  max-width: 1px;
  background-color: #fff;
`;
